import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
}));
